const EN = {
  subscribe_1: "{teacherCount} Teacher Accounts + {studentCount} Student Accounts Included",
  subscribe_2: "Unlimited Content Library Access",
  subscribe_3: "AI Generation for Idea Talk, Idea Meet, Idea Present, Idea Quiz, and Idea Read",
  subscribe_4: "Smart Conversations with Idea Talk & Idea Meet",
  subscribe_5: "Publish Idea Work",
  School_Edition: "School Edition",
  Content: "Content",
  AI_Generation_Quota: "AI Generation Quota",
  account_validity_time: "Account Validity Time",
  Remaining_Tokens_for_this_Month: "Remaining Tokens for this Month",
  token_tips: "Your IF Token is insufficient, please contact the administrator to purchase",
  token_tips_2: "Your IF Token is insufficient, please go to the store to purchase",
  Go_to_Store: "Go to Store",
  consume: "Consume"
};

const ZH_HK = {
  subscribe_1: "包含{teacherCount}個教師賬號及{studentCount}個學生賬號",
  subscribe_2: "無限使用內容庫",
  subscribe_3: "AI生成Idea Talk,Idea Meet,Idea Present,Idea Quiz,Idea Read",
  subscribe_4: "Idea Talk,Idea Meet 智能对话",
  subscribe_5: "可發佈Idea Work",
  School_Edition: "學校版",
  Content: "內容",
  AI_Generation_Quota: "AI生成次數",
  account_validity_time: "賬戶有效時間",
  Remaining_Tokens_for_this_Month: "本月剩余Token數",
  token_tips: "你的IF Token不足，請聯系管理員購買",
  token_tips_2: "你的IF Token不足，請前往商城購買",
  Go_to_Store: "前往商城",
  consume: "消耗"
};

const ZH_CN = {
  subscribe_1: "包含{teacherCount}个教师账号及{studentCount}个学生账号",
  subscribe_2: "无限使用内容库",
  subscribe_3: "AI生成生成课堂研讨,阅读理解,问答测验",
  subscribe_4: "课堂研讨 智能对话",
  subscribe_5: "可发布课后作业",
  School_Edition: "学校版",
  Content: "内容",
  AI_Generation_Quota: "AI生成次数",
  account_validity_time: "账户有效时间",
  Remaining_Tokens_for_this_Month: "本月剩余Token数",
  token_tips: "你的IF Token不足，请联系管理员购买",
  token_tips_2: "你的IF Token不足，请前往商城购买",
  Go_to_Store: "前往商城",
  consume: "消耗"
};

const es = {
  subscribe_1:
    "{teacherCount} Cuentas de Profesores + {studentCount} Cuentas de Estudiantes Incluidas",
  subscribe_2: "Biblioteca de contenidos ilimitada",
  subscribe_3: "Creación con IA de Idea Talk, Idea Meet, Idea Present, Idea Quiz e Idea Read",
  subscribe_4: "Interacciones inteligentes con Idea Talk e Idea Meet",
  subscribe_5: "Publicación de Idea Work",
  School_Edition: "Edición de Escuela",
  Content: "Contenido",
  AI_Generation_Quota: "Cuota de Generación de IA",
  account_validity_time: "Tiempo de validez de la cuenta",
  Remaining_Tokens_for_this_Month: "Tokens restantes para este mes",
  token_tips: "Tu IF Token es insuficiente, por favor contacta al administrador para comprar",
  token_tips_2: "Tu IF Token es insuficiente, por favor ve a la tienda para comprar",
  Go_to_Store: "Ir a la tienda",
  consume: "Consumir"
};

export default {
  EN,
  ZH_HK,
  es,
  ZH_CN
};
